// 客服工单公用方法
import { imgRegular, imgRegularBase } from '@/common/utils/tool'
import { workOrder, workOrderMin, arbitration, quality, qualityMin, postalOrder, postalOrderMin, orderTask } from './option'
export default {
  data() {
    return {
      workOrderMin, arbitration, quality, qualityMin, postalOrder, postalOrderMin, orderTask,
      listMinObj: {
        postalOrderList: [], // 邮政工单
        qualityMinList: [],
        workOrderMinList: [],
        claimOrderMinList: [], // 理赔
        platOrderMinList: [] , // 平台
        eventWorkOrderMinList: [], // 事件工单
        orderTaskMinList: [] // 催件任务单
      },
      fileListResAll: [],
      annexDialogVisible: false
    }
  },
  computed: {
    workOrderTable() {
      return [
        {
          title: '普通工单',
          listAll: 'workOrderList', // 外层table数据
          option: {// 外层table表头字段
            ...workOrder,
            head: workOrder.head.map(o => {
              return { ...o, toggle: false }
            })
          },
          listMin: 'workOrderMinList', // 里层table数据
          optionMin: workOrderMin, // 里层table字段
          getItem: this.setWorkOrderMinListAll// 点击展开处理函数
        },
        {
          title: '催件任务单',
          tabName: 'workOrder',
          listAll: 'orderTaskList', // 外层table数据
          option: orderTask,
          listMin: 'orderTaskMinList', // 里层table数据
          optionMin: workOrderMin, // 里层table字段
          getItem: this.setWorkOrderMinListAll// 点击展开处理函数
        },
        {
          title: '理赔工单',
          listAll: 'claimOrderList',
          option: {
            ...workOrder,
            head: workOrder.head.map(o => {
              return { ...o, toggle: false }
            }).filter(o => o.prop !== 'workOrderType')
          },
          listMin: 'claimOrderMinList',
          optionMin: workOrderMin,
          getItem: this.setWorkOrderMinListAll// 点击展开处理函数
        },
        {
          title: '平台工单',
          listAll: 'platOrderList',
          option: {
            ...workOrder,
            head: workOrder.head.map(o => {
              return { ...o, toggle: false }
            }).filter(o => o.prop !== 'workOrderType')
          },
          listMin: 'platOrderMinList',
          optionMin: workOrderMin,
          getItem: this.setWorkOrderMinListAll// 点击展开处理函数
        },
        {
          title: '邮政工单',
          listAll: 'postalOrderAllList',
          option: postalOrder,
          listMin: 'postalOrderList',
          optionMin: postalOrderMin,
          getItem: this.setPostalOrderList// 点击展开处理函数
        },
        {
          title: '事件工单',
          tabName: 'workOrder',
          listAll: 'eventWorkOrderList', // 外层table数据
          option: {// 外层table表头字段
            ...workOrder,
            head: workOrder.head.map(o => {
              return { ...o, toggle: false }
            })
          },
          listMin: 'eventWorkOrderMinList', // 里层table数据
          optionMin: workOrderMin, // 里层table字段
          getItem: this.setWorkOrderMinListAll// 点击展开处理函数
        },
        {
          title: '仲裁工单',
          listAll: 'arbitrationList',
          option: arbitration
        },
        {
          title: '质量工单',
          listAll: 'qualityList',
          option: quality,
          listMin: 'qualityMinList',
          optionMin: qualityMin,
          getItem: this.setQualityMinList// 点击展开处理函数
        }
      ]
    }
  },
  methods: {
    // 预览附件
    showAllDiglog(paths, prop) {
      const isObj = typeof paths[0] === 'object'
      this.fileListResAll = isObj ? paths.map(o => o[prop]) : paths
      this.annexDialogVisible = true
    },
    /**
     * 邮政工单信息子
     */
    setPostalOrderList(item) {
      this.listMinObj.postalOrderList = item.processRecordList || []
    },
    // 质量
    setQualityMinList(item) {
      this.listMinObj.qualityMinList = item.problemExpressWoLogIntegrationVOS || []
    },
    handleShowImg(url = [], keyName, isDownload) {
      if (keyName) {
        url = url.map(o => o[keyName])
      }
      const imgs = url.filter(o => o.match(imgRegular))
      this.$openImagePreview(imgs)
      url.map(file => {
        if (!file.match(imgRegular)) {
          isDownload && window.open(file)
        }
      })
    },
    setWorkOrderMinListAll(item, propList) {
      this.listMinObj[propList] = item.processRecords || []
      // 分离文件和图片
      item.processRecords.find((o, index) => {
        if (o.urls) {
          const urls = o.urls
          const imgs = []
          const files = []
          urls.map(o => {
            o.match(imgRegularBase) ? imgs.push(o) : files.push(o)
          })
          this.listMinObj[propList][index].enclosure = []
          this.listMinObj[propList][index].enclosure[0] = imgs
          this.listMinObj[propList][index].enclosure[1] = files
        }
      })
    }
  }
}
